module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("销售概览")])], 1), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1"
    }
  }, [_c('tr', [_c('td', [_c('el-select', {
    attrs: {
      "placeholder": "机器编号"
    },
    on: {
      "change": function($event) {
        _vm.kioskNoStatus()
      }
    },
    model: {
      value: (_vm.kioskNo),
      callback: function($$v) {
        _vm.kioskNo = $$v
      },
      expression: "kioskNo"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部售货机",
      "value": ""
    }
  }, [_vm._v("全部售货机")]), _vm._v(" "), _vm._l((_vm.kioskList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.deviceName,
        "value": item.deviceId
      }
    })
  })], 2)], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('tr', [_c('el-button', {
    staticStyle: {
      "margin": "5px",
      "width": "30%",
      "height": "70px",
      "font-size": "25px"
    }
  }, [_vm._v(" " + _vm._s(_vm.orderCount) + "\n                "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("销售数量")])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "5px",
      "width": "30%",
      "height": "70px",
      "font-size": "25px"
    }
  }, [_vm._v("\n                " + _vm._s("￥" + _vm.orderPrice)), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("销售金额")])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "5px",
      "width": "30%",
      "height": "70px",
      "font-size": "25px"
    }
  }, [_vm._v("\n                " + _vm._s("￥" + _vm.guestPrice)), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("客单价")])])], 1), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#eeeeee"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                    筛选日期：\n                "), _c('el-date-picker', {
    staticClass: "m-1",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "type": "daterange",
      "align": "right",
      "clearable": false,
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.datatime),
      callback: function($$v) {
        _vm.datatime = $$v
      },
      expression: "datatime"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.drawLine()
      }
    }
  }, [_vm._v("筛选")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_vm._v("\n                    快速查看："), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.timeFind(6)
      }
    }
  }, [_vm._v("近7天")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.timeFind(29)
      }
    }
  }, [_vm._v("近30天")])], 1)], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#eeeeee",
      "text-align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kioskNoFlag),
      expression: "kioskNoFlag"
    }],
    staticStyle: {
      "font-weight": "bold",
      "margin": "10px 10px 10px 30px"
    }
  }, [_vm._v("售货机排行榜")])]), _vm._v(" "), _c('tr', [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kioskNoFlag),
      expression: "kioskNoFlag"
    }],
    staticStyle: {
      "width": "70%",
      "margin-left": "10%"
    },
    attrs: {
      "data": _vm.tableDatakiosk,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50",
      "label": "排名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kioskNo",
      "label": "售货机ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "kioskName",
      "label": "售货机名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sumPrice",
      "label": "付款金额"
    }
  })], 1)], 1), _vm._v(" "), _c('tr', {
    staticStyle: {
      "background-color": "#eeeeee",
      "text-align": "center"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productFlag),
      expression: "productFlag"
    }],
    staticStyle: {
      "font-weight": "bold",
      "margin": "10px 10px 10px 30px"
    }
  }, [_vm._v("商品排行榜")])]), _vm._v(" "), _c('tr', [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.productFlag),
      expression: "productFlag"
    }],
    staticStyle: {
      "width": "70%",
      "margin-left": "10%"
    },
    attrs: {
      "data": _vm.tableDatapro,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50",
      "label": "排名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "单价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "counSKU",
      "label": "付款数量"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "#eeeeee"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold",
      "margin": "10px 10px 10px 30px"
    }
  }, [_vm._v("今日实时")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('div', {
    staticStyle: {
      "height": "400px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "margin-top": "40px"
    },
    attrs: {
      "id": "myChart",
      "height": "400"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a42167c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/chart/appletSaleCount.vue
// module id = 1084
// module chunks = 2